"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelectedDeliveryQuery = void 0;
var _fetching = require("@ori/fetching");
var _swrConfig = require("../constants/swrConfig");
var _useAnalytics = require("../hooks/useAnalytics");
var _useUrlOptions = require("../hooks/useUrlOptions");
var _logger = require("../logger");
var _utils = require("../utils");
const useSelectedDeliveryQuery = ({
  onSuccess
}) => {
  const {
    originalSelectedDeliveryItem
  } = (0, _useAnalytics.useAnalytics)();
  const {
    cacheKeys,
    urlOptions
  } = (0, _useUrlOptions.useUrlOptions)('/system/ajax/DeliverySelection/GetSelectedDelivery');
  const {
    data: lastDeliveryItem,
    error: lastDeliveryError,
    isValidating: isSelectedDeliveryLoading,
    mutate: mutateSelectedDelivery
  } = (0, _fetching.useSWR)(cacheKeys, async () => (0, _utils.getUrl)(urlOptions), {
    ..._swrConfig.errorHandlingSwrOptions,
    onSuccess: lastSelectedItem => {
      (0, _logger.logInfo)('useSelectedDeliveryQuery() hook finished successfully. lastDeliveryItem:', lastSelectedItem);
      onSuccess?.(lastSelectedItem);
    },
    onError: error => {
      _logger.mainLogger.error(error, {
        action: 'useSelectedDeliveryQuery'
      });
    }
  });
  if (lastDeliveryItem !== undefined && originalSelectedDeliveryItem.current === undefined) {
    // remember previously selected item for analytics
    // eslint-disable-next-line react-compiler/react-compiler -- want to store the value here
    originalSelectedDeliveryItem.current = lastDeliveryItem;
    (0, _logger.logDebug)('Previously selected delivery item was stored for analytics:', lastDeliveryItem);
  }
  return {
    lastDeliveryError,
    lastDeliveryItem,
    isSelectedDeliveryLoading,
    mutateSelectedDelivery
  };
};
exports.useSelectedDeliveryQuery = useSelectedDeliveryQuery;